module.exports = require('./dist').default;
module.exports.default = module.exports;




//////////////////
// WEBPACK FOOTER
// /Users/sheweichun/npmplace/tumbling/node_modules/.3.10.1@inferno-component/index.js
// module id = 17
// module chunks = 0